import { Link } from '@vp/swan';
import type { CtaLink } from '../../messages';

export type CtaLinkAnchorProps = {
    link: CtaLink;
    onClick?: (url: string, label: string) => void;
};

export function CtaLinkAnchor({ link, onClick }: CtaLinkAnchorProps) {
    return (
        <>
            {' '}
            <Link
                href={link.url}
                target="_blank"
                rel="noopener"
                onClick={() => onClick?.(link.url, link.label)}
            >
                {link.label}
            </Link>
        </>
    );
}
